import React from "react";
import { Button, PlusIcon } from "@pd/pd-ui-kit";
import { useTranslation } from "react-i18next";

interface IEducationalProgramsManagementControlProps {
  onAdd: () => void;
  disabledControl?: boolean;
}

export const EducationalProgramsManagementControl = (
  props: IEducationalProgramsManagementControlProps,
) => {
  const { onAdd, disabledControl } = props;
  const { t } = useTranslation();

  return (
    <Button
      onClick={onAdd}
      size={"middle"}
      icon={<PlusIcon size={16} />}
      disabled={disabledControl}
    >
      {t("patp.add_course")}
    </Button>
  );
};
